export default "__VITE_ASSET__5da19bb1__"